import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAppPath, rememberReturnTo } from 'lib/returnTo';
import { paths, ROOT_PATHS } from './paths';

export const SignedOutRedirect = () => {
  const location = useLocation();

  if (!isAppPath(location.pathname)) {
    return <Navigate to={ROOT_PATHS.WEBSITE} replace={true} />;
  }

  rememberReturnTo(`${location.pathname}${location.search}${location.hash}`);
  return <Navigate to={paths.auth.login} replace={true} />;
};
